<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
  <g fill="none" fill-rule="evenodd">
    <g>
      <g>
        <g transform="translate(-32 -649) translate(32 648) translate(0 1)">
          <path d="M0 0H30V30H0z"/>
          <rect width="7.667" height="28.476" x="4" y="1" fill="#FFF" rx="2"/>
          <rect width="7.667" height="28.476" x="19.333" y="1" fill="#FFF" rx="2"/>
        </g>
      </g>
    </g>
  </g>
</svg>
